import { API_BASE_URL, API_PATHS } from "../utils/constants/api.constants";
import axiosInstance from "../utils/authUtils";


class AuthService {

    /* ================= LOGIN ================= */

    static async login(item) {
        try {

            const response = await axiosInstance.post(
                API_BASE_URL + API_PATHS.userlogin,
                item
            );

            const responseData = response?.data;

            console.log("LOGIN API RESPONSE:", responseData);

            // Your API returns status: 1
            if (
                responseData &&
                (
                    responseData.status === 1 ||
                    responseData.status === true
                )
            ) {

                const userData = responseData.data;

                if (!userData) {
                    throw new Error(
                        "User data not received"
                    );
                }

                // Remove sensitive fields before storing user
                const {
                    accessToken,
                    refreshToken,
                    password,
                    ...user
                } = userData;


                /* ===============================
                   SESSION STORAGE
                   Clears when browser/tab session
                   ends
                =============================== */

                sessionStorage.setItem(
                    "user",
                    JSON.stringify(user)
                );

                if (accessToken) {
                    sessionStorage.setItem(
                        "accessToken",
                        accessToken
                    );
                }

                if (refreshToken) {
                    sessionStorage.setItem(
                        "refreshToken",
                        refreshToken
                    );
                }

                sessionStorage.setItem(
                    "isLoggedIn",
                    "true"
                );

                return responseData;

            } else {

                throw new Error(
                    responseData?.message ||
                    "Invalid credentials"
                );
            }

        } catch (err) {

            console.error(
                "LOGIN SERVICE ERROR:",
                err
            );

            return Promise.reject(err);
        }
    }


    /* ================= REGISTER ================= */

    static async register(item) {
        try {

            const response = await axiosInstance.post(
                API_BASE_URL + API_PATHS.userRegister,
                item
            );

            const responseData = response?.data;

            // Support status: 1 or success: true
            if (
                responseData &&
                (
                    responseData.status === 1 ||
                    responseData.status === true ||
                    responseData.success === true
                )
            ) {
                return responseData;
            }

            throw new Error(
                responseData?.message ||
                "Registration failed"
            );

        } catch (err) {
            return Promise.reject(err);
        }
    }


    /* ================= STATS ================= */

    static getStats(item) {

        const api =
            `${API_BASE_URL}${API_PATHS.orggetStats}` +
            `?range=${item.range}&orgId=${item.orgId}`;

        return axiosInstance.get(api);
    }


    /* ================= COUNTS ================= */

    static getCounts(item) {

        const api =
            `${API_BASE_URL}${API_PATHS.orggetDashCount}` +
            `?range=${item.range}&orgId=${item.orgId}`;

        return axiosInstance.get(api);
    }


    /* ================= REMOVE USER ================= */

    static removeUserDetails() {

        sessionStorage.removeItem("user");
        sessionStorage.removeItem("accessToken");
        sessionStorage.removeItem("refreshToken");
        sessionStorage.removeItem("isLoggedIn");
    }


    /* ================= GET USER ================= */

    static getUserDetails() {

        const user = sessionStorage.getItem("user");

        try {

            return user
                ? JSON.parse(user)
                : null;

        } catch (e) {

            console.error(
                "Error parsing user details:",
                e
            );

            return null;
        }
    }


    /* ================= SET TOKENS ================= */

    static setTokens(data) {

        const userData = data?.data;

        if (userData?.accessToken) {

            sessionStorage.setItem(
                "accessToken",
                userData.accessToken
            );
        }

        if (userData?.refreshToken) {

            sessionStorage.setItem(
                "refreshToken",
                userData.refreshToken
            );
        }
    }
}


export default AuthService;